// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /subaccounts/anticipations/lista/{subaccount_id}
 *
 * Optional query filters for the anticipations listing: status filter plus
 * limit/offset pagination. Mirrors the filters built in
 * anticipations.php::lista() and consumed by
 * Payment_anticipations_model::getBySubaccount().
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_ListaInput {
status?: string
limit?: number
offset?: number
}

registerContract('SubaccountsAnticipations_ListaInput', {
  status: { type: 'string',  required: false },
  limit:  { type: 'number',  required: false },
  offset: { type: 'number',  required: false },
})
